import {H3, H2, PNoMargin} from '@/typography';
import {SectionPadding} from '@/section';
import Container from '@/container';
import {Row, Col} from '@/grid';
import {withMarginBottomDoubleXlToXl} from '@/hocs/withSpacing';
import {withBgYellow50} from '@/hocs/withColors';
import {withUppercase} from '@/hocs/withFontType';
import {GridLayout, GridItem} from '@/ui/grid/grid-layout';
import BoxGrid from '@/ui/box-grid';
import PictureWrapper from '@/ui/images-wrapper';
import {withTextLeftToCenter} from '@/hocs/withAlignment';
import {useTranslations} from 'next-intl';
import {DivMargined, FeatureItem, Grid} from '@/content/features/shared';

const imgPath = '/static/images/features/applicant-tracking/';

const Yellow50Section = withBgYellow50(SectionPadding);
const RowMargined = withMarginBottomDoubleXlToXl(Row);
const H3Upper = withTextLeftToCenter(withUppercase(withMarginBottomDoubleXlToXl(H3)));

const ApplicantTrackingSection = () => {
  const t = useTranslations('features.applicantTracking');

  const CandidateEvaluationFeaturesArray = t.raw('candidateEvaluation.features') as FeatureItem[];
  const CollaborationToolsFeaturesArray = t.raw('collaborationTools.features') as FeatureItem[];
  const AutomationHiringFeaturesArray = t.raw('automationHiring.features') as FeatureItem[];
  const ReportingFeaturesArray = t.raw('reporting.features') as FeatureItem[];
  const AccessAndPermissionsFeaturesArray = t.raw(
    'accessAndPermissions.features'
  ) as FeatureItem[];

  return (
    <Yellow50Section>
      <Container>
        <Grid fluid>
          <RowMargined center="xs" start="lg" middle="xs">
            <Col xs={12} lg={4}>
              <H2>{t('title')}</H2>
            </Col>
            <Col xs={12} lg={8}>
              <PictureWrapper
                imgPath={imgPath}
                imageUrl="applicant-tracking-system"
                imageTypeFallback="jpg"
                altImage={t('imageAlt')}
              />
            </Col>
          </RowMargined>

          <DivMargined>
            <H3Upper className="heading-4">
              {t('candidateEvaluation.title')}
            </H3Upper>
            <GridLayout Col={3} lgCol={2} autoRows>
              {CandidateEvaluationFeaturesArray.map((item, index) => (
                <GridItem key={index}>
                  <BoxGrid backgroundColor="var(--yellow100)">
                    <H3>{item.title}</H3>
                    <PNoMargin>{item.copy}</PNoMargin>
                  </BoxGrid>
                </GridItem>
              ))}
            </GridLayout>
          </DivMargined>

          <DivMargined>
            <H3Upper className="heading-4">
              {t('collaborationTools.title')}
            </H3Upper>
            <GridLayout Col={3} lgCol={2} autoRows>
              {CollaborationToolsFeaturesArray.map((item, index) => (
                <GridItem key={index}>
                  <BoxGrid backgroundColor="var(--yellow100)">
                    <H3>{item.title}</H3>
                    <PNoMargin>{item.copy}</PNoMargin>
                  </BoxGrid>
                </GridItem>
              ))}
            </GridLayout>
          </DivMargined>

          <DivMargined>
            <H3Upper className="heading-4">
              {t('automationHiring.title')}
            </H3Upper>
            <GridLayout Col={3} lgCol={2} autoRows>
              {AutomationHiringFeaturesArray.map((item, index) => (
                <GridItem key={index}>
                  <BoxGrid backgroundColor="var(--yellow100)">
                    <H3>{item.title}</H3>
                    <PNoMargin>{item.copy}</PNoMargin>
                  </BoxGrid>
                </GridItem>
              ))}
            </GridLayout>
          </DivMargined>

          <DivMargined>
            <H3Upper className="heading-4">{t('reporting.title')}</H3Upper>
            <GridLayout Col={3} lgCol={2} autoRows>
              {ReportingFeaturesArray.map((item, index) => (
                <GridItem key={index}>
                  <BoxGrid backgroundColor="var(--yellow100)">
                    <H3>{item.title}</H3>
                    <PNoMargin>{item.copy}</PNoMargin>
                  </BoxGrid>
                </GridItem>
              ))}
            </GridLayout>
          </DivMargined>

          <DivMargined>
            <H3Upper className="heading-4">
              {t('accessAndPermissions.title')}
            </H3Upper>
            <GridLayout Col={3} lgCol={2} autoRows>
              {AccessAndPermissionsFeaturesArray.map((item, index) => (
                <GridItem key={index}>
                  <BoxGrid backgroundColor="var(--yellow100)">
                    <H3>{item.title}</H3>
                    <PNoMargin>{item.copy}</PNoMargin>
                  </BoxGrid>
                </GridItem>
              ))}
            </GridLayout>
          </DivMargined>
        </Grid>
      </Container>
    </Yellow50Section>
  );
};

export default ApplicantTrackingSection;
